export const enum ResStatus {
    RES_STANDBY = 0, // 서비스점검중
    RES_SUCCESS = 200,
    RES_FAIL = 400, // FAIL (잘못된 요청)

    RES_UNAUTHORIZED = 401, // 권한이 없음 (인증 실패)
    RES_FORBIDDEN = 403, // 서버가 요청 거부 (인가 실패)
    RES_NOTFOUND = 404, // 찾을 수 없음
    RES_INTERNAL_SERVER_ERROR = 500, // 서버 내부 오류
    RES_NOT_IMPLEMENT = 501, // 구현되지 않음 (서버에 요청을 수행할 수 있는 기능이 없음)
    RES_NOT_SERVICE = 900, // 서비스 중지중

    RES_SQLEXCEPTION = 1000,
    RES_PG_FAIL = 1006,
    RES_ALREADY_ACCOUNT = 9100, // SQL Exception
    RES_NOTFOUND_ACCOUNT = 9101, // NOT_FOUND_ACCOUNT
    RES_BLOCKED_ACCOUNT = 9102, // 차단된 계정
    RES_STOPED_ACCOUNT = 9103, // 정지된 계정
}

export const enum OrderStatus {
    COMPLETE_PAYMENT = 1, // 결제완료, 주문완료-수거대기, 픽업을 준비중입니다, 주문취소가능, 픽업일정 수정가능
    CANCEL_ORDER = 2, // 주문취소
    PICKUP = 3, // 픽업중
    PICKUP_COMPLETE = 4, // 픽업완료, 수거완료
    MINTING = 5, // 민트중, 작업시작
    MINT_COMPLETE = 6, // 민트완료, 작업종료
    SHIPPING = 7, // 배송중, 출고->배송시작
    DELIVERY_COMPLETE = 8, // 배송완료
    REJECT_ORDER = 9,
    REQUESTING = 100, // 견적요청중
    WAITING_ORDER = 101, // 주문대기중
    ETC = 200,
}

export const enum ProgressStatus {
    RESULT_1 = 1, // 접수완료
    RESULT_2 = 2, // 제품발송
    RESULT_3 = 3, // 제품도착
    RESULT_4 = 4, // 검수완료
    RESULT_5 = 5, // 결제완료
    RESULT_6 = 6, // 작업중
    RESULT_7 = 7, // 작업완료
    RESULT_8 = 8, // 배송중
    RESULT_9 = 9, // 배송완료
    RESULT_10 = 10, // 접수취소-진행불가
    RESULT_11 = 11, // 접수후 바로 취소
    RESULT_12 = 12, // 반송중
    RESULT_13 = 13, // 반송완료
}

export const enum PaymentStatus { // 2 현장카드결제, 3 현금,계좌이체, 4 SMS결제
    NONE = 0,
    PAID = 1,
    CANCEL_PART = 2,
    CANCEL = 3,
    REQUEST_OVER = 7,
    REQUEST_CANCEL = 8,
    REQUEST = 9,
}
